import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// @Interticket imports
import { FormModule, MaterialModule, PipeModule, SsrModule, TranslateModule } from '@interticket/core';
import { ITCommonModule } from 'common';
import { ButtonRemoveComponent } from './components/button-remove/button-remove.component';
// Components
import { CalloutComponent } from './components/callout/callout.component';
import { CustomCalloutComponent } from './components/custom-callout/custom-callout.component';
import { CustomModalComponent } from './components/custom-modal/custom-modal.component';
import { CustomSidebarComponent } from './components/custom-sidebar/custom-sidebar.component';
import { DatetimeOffsetComponent } from './components/datetime-offset/datetime-offset.component';
import { EventCardListItemComponent } from './components/event/event-card-list-item/event-card-list-item.component';
import { EventCardComponent } from './components/event/event-card/event-card.component';
import { OnlineEventWatchStreamIconComponent } from './components/event/online-event-watch-stream-icon/online-event-watch-stream-icon.component';
import { AppFormControlDirective } from './components/forms/app-form-control.directive';
// Directives
import { AppFormDirective } from './components/forms/app-form.directive';
import { AppShowErrorsDirective } from './components/forms/show-errors.directive';
import { ImageComponent } from './components/image/image.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ProfileDropdownComponent } from './components/profile-dropdown/profile-dropdown.component';
import { ForAuthDirective } from './directives/for-auth.directive';
// Pipes
import { AddressPipe } from './pipes/address.pipe';
import { CurrenciesPipe } from './pipes/currencies.pipe';
import { ImagePipe } from './pipes/image.pipe';
import { PaymentUrl } from './pipes/payment-url.pipe';
import { PriceIntervalPipe } from './pipes/price-interval.pipe';
import { ReadTimePipe } from './pipes/read-time.pipe';
import { SlugifyPipe } from './pipes/slugify.pipe';
import { StreamPipe } from './pipes/stream.pipe';
import { TimezonePipe } from './pipes/timezone.pipe';


// Interticket modules
const interticketModules = [
  FormModule,
  TranslateModule,
  PipeModule,
  ITCommonModule,
  SsrModule,
  MaterialModule,
];

// Components
const components = [
  EventCardComponent,
  EventCardListItemComponent,
  CustomSidebarComponent,
  CalloutComponent,
  CustomCalloutComponent,
  CustomModalComponent,
  ImageComponent,
  LoaderComponent,
  OnlineEventWatchStreamIconComponent,
  DatetimeOffsetComponent,
  ButtonRemoveComponent,
  ProfileDropdownComponent,
];

// Directives
const directives = [
  AppFormDirective,
  AppShowErrorsDirective,
  AppFormControlDirective,
  ForAuthDirective,
];

// Pipes
const pipes = [
  AddressPipe,
  ReadTimePipe,
  TimezonePipe,
  PriceIntervalPipe,
  ImagePipe,
  StreamPipe,
  PaymentUrl,
  SlugifyPipe,
  CurrenciesPipe,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ...interticketModules,
  ],
  declarations: [
    ...components,
    ...directives,
    ...pipes,
  ],
  exports: [
    CommonModule,
    ...interticketModules,
    ...components,
    ...directives,
    ...pipes,
  ],
})
export class SharedModule { }
